import * as actionTypes from './actionTypes'
import Papa from 'papaparse';
import currentCongressListCsv from '../../current-congress-list.csv';
import newMembersOfCongressCsv from '../../new-members-of-congress.csv';
import localCongressionalDistrictsCsv from '../../local-congressional-districts.csv'
import voteLookupsProPublica from '../../vote_lookups_pro_publica.txt';
import voteLookupsAddendum from '../../hr_9747_votes.txt';
import voteLookupsPn1789 from '../../pn_1789_votes.txt';
import voteLookupsBigBeautifulBill from '../../big_beautiful_bill_votes.txt';
import voteLookupsBigBeautifulHouse2 from '../../big_beautiful_house_round2.txt';
import voteLookupsFlexibility from '../../flexibility-votes.txt';
import voteLookupsPrudent from '../../prudent-votes.txt';
import blankUser from '../../seal.png';
import axios from 'axios';
import Helpers from '../../helpers/Helpers';
import membersOfCongressDetails from '../../members_of_congress_details.txt';


const joeBidenMember = {
    bioGuideId: '0',
    memShortTitle: 'Pres',
    memImage: "https://www.whitehouse.gov/wp-content/uploads/2021/04/P20210303AS-1901.jpg",
    memName:"Pres. Joseph Biden", 
    memNameSub:"(D-USA)",
    vote1:"Support",
    vote2:"Support",
    vote3:"Support",
    vote4:"Support",
    memGrade:"Score: 100%"
}

const kamalaHarrisMember = {
    bioGuideId: '0',
    memShortTitle: 'Vice Pres',
    memImage: "https://www.whitehouse.gov/wp-content/uploads/2021/04/V20210305LJ-0043.jpg",
    memName:"Vice Pres. Kamala Harris", 
    memNameSub:"(D-USA)",
    vote1:"Support",
    vote2:"Support",
    vote3:"Support",
    vote4:"Support",
    memGrade:"Score: 100%"
}



//since there is no api call necessary, we only use the success action
export const currentMembersOfCongressGet = () =>{
    return dispatch =>{
        fetch(currentCongressListCsv)
        .then((response) => response.text())
        .then((textContent) => {
            Papa.parse(textContent, {
                    header: true,
                    skipEmptyLines: true,
                    complete: function (results) {
                    dispatch(currentMembersOfCongressGetSuccess(results.data));
                },
            });
        });
    };
}

export const currentMembersOfCongressGetSuccess = (resultsData) =>{
    return {
        type: actionTypes.GET_CURRENT_MEMBERS_OF_CONGRESS_SUCCESS, 
        currentMembersOfCongress: resultsData
    }
}

export const currentMembersOfCongressDetailsGet = (group) =>{
    
    const offset=((group-1)*250).toString();
    
    return dispatch =>{
        //use the address and 
        axios.get('https://api.congress.gov/v3/member/congress/119?offset=' + offset + '&limit=250&format=json&currentMember=true&api_key=TceuuNjElWDcvT3UQziRBBkKHpRiTbrQU7j55s0K') 
        .then(async response=>{
            dispatch(currentMembersOfCongressDetailsGetSuccess(response.data.members));
            //console.log(response.data.members);
        })
        .catch(err=>{
            console.log('err', err);
            console.log('err.response', err.response);
            dispatch(errorOnAction('We had trouble with your address.  Please try again.'));
        })
    }
}

export const currentMembersOfCongressDetailsLocalGet = () =>{

    return dispatch =>{
        fetch(membersOfCongressDetails)
        .then((res) => res.json()
          .then((data) => {
             dispatch(currentMembersOfCongressDetailsGetSuccess(data));
          })
        );
    }
}


export const currentMembersOfCongressDetailsGetSuccess = (resultsData) =>{
    return {
        type: actionTypes.GET_CURRENT_MEMBERS_OF_CONGRESS_DETAILS_SUCCESS, 
        currentMembersOfCongressDetails: resultsData
    }
}



export const newMembersOfCongressGet = () =>{
    return dispatch =>{
        fetch(newMembersOfCongressCsv)
        .then((response) => response.text())
        .then((textContent) => {
            Papa.parse(textContent, {
                    header: true,
                    skipEmptyLines: true,
                    complete: function (results) {
                    dispatch(newMembersOfCongressGetSuccess(results.data));
                },
            });
        });
    };
}


export const newMembersOfCongressGetSuccess = (resultsData) =>{
    return {
        type: actionTypes.GET_NEW_MEMBERS_OF_CONGRESS_SUCCESS, 
        newMembersOfCongress: resultsData
    }
}

export const localCongressionalDistrictsGet = () =>{
    return dispatch =>{
        fetch(localCongressionalDistrictsCsv)
        .then((response) => response.text())
        .then((textContent) => {
            Papa.parse(textContent, {
                    header: true,
                    skipEmptyLines: true,
                    complete: function (results) {
                    dispatch(localCongressionalDistrictsGetSuccess(results.data));
                },
            });
        });
    };
}

export const localCongressionalDistrictsGetSuccess = (resultsData) =>{
    return {
        type: actionTypes.GET_LOCAL_CONGRESSIONAL_DISTRICTS_SUCCESS, 
        localCongressionalDistricts: resultsData
    }
}

export const addressSearchResultsGet = (address, currentMembersOfCongress, currentMembersOfCongressDetails, voteRecords, newMembersOfCongress, voteRecordsAddendum, voteRecordsPn1789, voteRecordsBigBeautifulBill, voteRecordsBigBeautifulHouse2, voteRecordsFlexibility, voteRecordsPrudent) =>{

    return dispatch =>{
        //use the address and 
        //axios.get('https://www.googleapis.com/civicinfo/v2/representatives?key=AIzaSyCrOBuHS_EkvGYATbvhR_8Jmo7Xsb-ttec', 
        axios.get('https://www.googleapis.com/civicinfo/v2/divisionsByAddress?key=AIzaSyCrOBuHS_EkvGYATbvhR_8Jmo7Xsb-ttec', 
            //for testing{ params: { address: '5621 Jarist Drive Clifton, VA 20124' } }
            { params: { address: address } }
        )
        .then(async response=>{
            if(response.data.normalizedInput.line1 && response.data.normalizedInput.city){
                if (response.data.normalizedInput.state == "DC"){
                    dispatch(errorOnAction('District residents do not have voting representation in the House or Senate.  Please try another address.'));
                }
                else{
                    dispatch(addressSearchResultsGetSuccess(response.data, currentMembersOfCongress, currentMembersOfCongressDetails, voteRecords, newMembersOfCongress, voteRecordsAddendum, voteRecordsPn1789, voteRecordsBigBeautifulBill, voteRecordsBigBeautifulHouse2, voteRecordsFlexibility, voteRecordsPrudent));
                }                    
            }
            else
            {
                dispatch(errorOnAction('We had trouble with your address.  Please try again.')); 
            };
        })
        .catch(err=>{
            console.log('err', err);
            console.log('err.response', err.response);
            dispatch(errorOnAction('We had trouble with your address.  Please try again.'));
        })
    }
}

export const addressSearchResultsGetSuccess = (resultsData, currentMembersOfCongress, currentMembersOfCongressDetails, voteRecords, newMembersOfCongress, voteRecordsAddendum, voteRecordsPn1789, voteRecordsBigBeautifulBill, voteRecordsBigBeautifulHouse2, voteRecordsFlexibility, voteRecordsPrudent) =>{
    //init and push joe b
    const addressResultMembers=[];
    addressResultMembers.push(joeBidenMember);
    addressResultMembers.push(kamalaHarrisMember);
    
    //add the rep
    let addressRepAndSenMembers=Helpers.getMembersFromAddressSearch(resultsData, currentMembersOfCongress);
    if (addressRepAndSenMembers.length>0) {
        //get the image from the bioguideid
        addressRepAndSenMembers = Helpers.updateMembersImageLink(addressRepAndSenMembers, currentMembersOfCongressDetails);
        addressRepAndSenMembers = Helpers.updateMemberVotes(addressRepAndSenMembers, voteRecords, newMembersOfCongress, voteRecordsAddendum, voteRecordsPn1789, voteRecordsBigBeautifulBill, voteRecordsBigBeautifulHouse2, voteRecordsFlexibility, voteRecordsPrudent);
        addressRepAndSenMembers = Helpers.replaceMemberExceptions(addressRepAndSenMembers);
        addressResultMembers.push(...addressRepAndSenMembers);
    };
    return {
        type: actionTypes.GET_ADDRESS_SEARCH_RESULTS_SUCCESS, 
        addressSearchResults: resultsData,
        searchResultMembers: addressResultMembers
    }
}

export const districtSearchResultsGet = (address, currentMembersOfCongress, currentMembersOfCongressDetails, voteRecords, newMembersOfCongress, voteRecordsAddendum, voteRecordsPn1789, voteRecordsBigBeautifulBill, voteRecordsBigBeautifulHouse2, voteRecordsFlexibility, voteRecordsPrudent) =>{
    
    return dispatch =>{
        //get the information for my district based on the address
        const districtResultMembers=[];
        districtResultMembers.push(joeBidenMember);
        districtResultMembers.push(kamalaHarrisMember);
        
        let districtRepAndSenMembers=Helpers.getMembersFromDistrictSearch(address, currentMembersOfCongress);
        if (districtRepAndSenMembers.length>0) {
            //get the image from the bioguideid
            districtRepAndSenMembers = Helpers.updateMembersImageLink(districtRepAndSenMembers, currentMembersOfCongressDetails);
            districtRepAndSenMembers = Helpers.updateMemberVotes(districtRepAndSenMembers, voteRecords, newMembersOfCongress, voteRecordsAddendum, voteRecordsPn1789, voteRecordsBigBeautifulBill, voteRecordsBigBeautifulHouse2, voteRecordsFlexibility, voteRecordsPrudent);
            districtRepAndSenMembers = Helpers.replaceMemberExceptions(districtRepAndSenMembers);
            districtResultMembers.push(...districtRepAndSenMembers);
            dispatch(districtSearchResultsGetSuccess(districtResultMembers)); 
        }
        else
        {
            dispatch(errorOnAction('We had trouble with your address.  Please try again.')); 
        };
    }
    
}

export const districtSearchResultsGetSuccess = (results) =>{
    return {
        type: actionTypes.GET_DISTRICT_SEARCH_RESULTS_SUCCESS, 
        searchResultMembers: results
    }
}

export const voteRecordsGet = () =>{
    return dispatch =>{
        fetch(voteLookupsProPublica)
        .then((res) => res.json()
          .then((data) => {
             dispatch(voteRecordsGetSuccess(data));
          })
        );
    }
}

export const voteRecordsGetSuccess = (resultsData)=>{
    return {
        type: actionTypes.GET_VOTE_RECORDS_SUCCESS,
        voteRecords: resultsData
    }
}

export const voteRecordsAddendumGet = () =>{
    return dispatch =>{
        fetch(voteLookupsAddendum)
        .then((response) => response.text())
        .then((textContent) => {
            Papa.parse(textContent, {
                    header: true,
                    skipEmptyLines: true,
                    complete: function (results) {
                    dispatch(voteRecordsAddendumGetSuccess(results.data));
                },
            });
        });
    };
}

export const voteRecordsAddendumGetSuccess = (resultsData)=>{
    //alert(resultsData[0].member_id);
    //alert(resultsData[0].position);
    return {
        type: actionTypes.GET_VOTE_RECORDS_ADDENDUM_SUCCESS,
        voteRecordsAddendum: resultsData
    }
}

export const voteRecordsPn1789Get = () =>{
    return dispatch =>{
        fetch(voteLookupsPn1789)
        .then((response) => response.text())
        .then((textContent) => {
            Papa.parse(textContent, {
                    header: true,
                    skipEmptyLines: true,
                    complete: function (results) {
                    dispatch(voteRecordsPn1789GetSuccess(results.data));
                },
            });
        });
    };
}

export const voteRecordsPn1789GetSuccess = (resultsData)=>{
    //alert(resultsData[0].member_id);
    //alert(resultsData[0].position);
    return {
        type: actionTypes.GET_VOTE_RECORDS_PN1789_SUCCESS,
        voteRecordsPn1789: resultsData
    }
}

export const voteRecordsBigBeautifulBillGet = () =>{
    return dispatch =>{
        fetch(voteLookupsBigBeautifulBill)
        .then((response) => response.text())
        .then((textContent) => {
            Papa.parse(textContent, {
                    header: true,
                    skipEmptyLines: true,
                    complete: function (results) {
                    dispatch(voteRecordsBigBeautifulBillGetSuccess(results.data));
                },
            });
        });
    };
}

export const voteRecordsBigBeautifulBillGetSuccess = (resultsData)=>{
    //alert(resultsData[0].member_id);
    //alert(resultsData[0].position);
    return {
        type: actionTypes.GET_VOTE_RECORDS_BIG_BEAUTIFUL_BILL_SUCCESS,
        voteRecordsBigBeautifulBill: resultsData
    }
}

export const voteRecordsBigBeautifulHouse2Get = () =>{
    return dispatch =>{
        fetch(voteLookupsBigBeautifulHouse2)
        .then((response) => response.text())
        .then((textContent) => {
            Papa.parse(textContent, {
                    header: true,
                    skipEmptyLines: true,
                    complete: function (results) {
                    dispatch(voteRecordsBigBeautifulHouse2GetSuccess(results.data));
                },
            });
        });
    };
}

export const voteRecordsBigBeautifulHouse2GetSuccess = (resultsData)=>{
    //alert(resultsData[0].member_id);
    //alert(resultsData[0].position);
    return {
        type: actionTypes.GET_VOTE_RECORDS_BIG_BEAUTIFUL_HOUSE2_SUCCESS,
        voteRecordsBigBeautifulHouse2: resultsData
    }
}


export const voteRecordsFlexibilityGet = () =>{
    return dispatch =>{
        fetch(voteLookupsFlexibility)
        .then((response) => response.text())
        .then((textContent) => {
            Papa.parse(textContent, {
                    header: true,
                    skipEmptyLines: true,
                    complete: function (results) {
                    dispatch(voteRecordsFlexibilityGetSuccess(results.data));
                },
            });
        });
    };
}

export const voteRecordsFlexibilityGetSuccess = (resultsData)=>{
    //alert(resultsData[0].member_id);
    //alert(resultsData[0].position);
    return {
        type: actionTypes.GET_VOTE_RECORDS_FLEXIBILITY_SUCCESS,
        voteRecordsFlexibility: resultsData
    }
}

export const voteRecordsPrudentGet = () =>{
    return dispatch =>{
        fetch(voteLookupsPrudent)
        .then((response) => response.text())
        .then((textContent) => {
            Papa.parse(textContent, {
                    header: true,
                    skipEmptyLines: true,
                    complete: function (results) {
                    dispatch(voteRecordsPrudentGetSuccess(results.data));
                },
            });
        });
    };
}

export const voteRecordsPrudentGetSuccess = (resultsData)=>{
    //alert(resultsData[0].member_id);
    //alert(resultsData[0].position);
    return {
        type: actionTypes.GET_VOTE_RECORDS_PRUDENT_SUCCESS,
        voteRecordsPrudent: resultsData
    }
}


export const searchResultsClear = () => {
    return {
        type: actionTypes.CLEAR_SEARCH_RESULTS
    }
}


export const errorOnAction = (errorMessage) =>{
    return {
        type: actionTypes.ACTION_ERROR, 
        actionErrorMessage: errorMessage
    }
}